export default __webpack_public_path__ + "static/media/Voting-rafiki.965ef985.svg";